import { Link } from 'gatsby'
import React from 'react'
import { useBreakpoint } from 'gatsby-plugin-breakpoints';

import Icon from "../images/icon.inline.svg";



export default function Navbar() {
    const breakpoints = useBreakpoint();
    if (breakpoints.tablet) {
        return (
            <nav className="nav">
                {/* <h1>Geekay eSports</h1> */}
                {/* <img src="images/icon.png" alt="Logo" className="logo" /> */}
                <Icon className="logo"/>
                <div className="nav-right">
                    <div className="links">
                        <Link to="/">Home</Link>
                        <Link to="/about">About Us</Link>
                        <a href="https://www.geekaygames.com/">Store</a>
                    </div>
                </div>
            </nav>
        )
    }
    else {
        return (
            <nav className="nav">
                {/* <h1>Geekay eSports</h1> */}
                {/* <img src="images/icon.png" alt="Logo" className="logo" /> */}
                <Icon className="logo"/>
                <div className="nav-right">
                    <div className="links">
                        <Link to="/">Home</Link>
                        <Link to="/about">About Us</Link>
                        {/* <Link to="/sponsors">Our sponsors</Link> */}
                        <a href="https://www.geekaygames.com/">Store</a>
                        {/* <Link to="/contact">Contact Us</Link> */}
                    </div>
                </div>
            </nav>
        )
    }
}
